import styles from "./CustomerAvatar.module.scss";
import { AuthContext } from "../../Contexts/AuthContext";
import { useContext } from "react";

const CustomerAvatar = () => {
  const { user } = useContext(AuthContext);
  return (
    <div className={styles.customer_avatar}>
      <h4>
        Hello {user.first_name} {user.last_name}!
      </h4>
      <p>
        Your client number: <span>{user.id}</span>
      </p>
    </div>
  );
};

export default CustomerAvatar;
